import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'
import Select from "react-select";
import ESPUmcReportingTable from './ESPUmcReportingTable'
import api from '../../utils/api';
import { ControlledInput } from '../../common/Input/Input';
import { Button } from '../../common/Button/Button';
import MultiSelectAll from '../../common/Multiselect/MultiSelectAll';
import { toast } from 'react-toastify';
import Spinner from '../../common/Spinner/Spinner';
import Modal from 'react-modal'
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from "../../assets/ic_close_wh.svg"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { format } from 'date-fns';
import { styled } from '@material-ui/core';

const ESPUmcReportingInterface = () => {

    const gridRef = useRef()
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [isClearAction, setIsClearAction] = useState(false);

    const [oppTypeNameList, setOppTypeNameList] = useState()
    const [selectedOppType, setSelectedOppType] = useState(null)

    const [oppTitleNameList, setOppTitleNameList] = useState([])
    const [selectedOppTitle, setSelectedOppTitle] = useState([])

    const [businessSectorList, setBusinessSectorList] = useState([])
    const [selectedBusinessSector, setSelectedBusinessSector] = useState([])

    const [tagsDropDownList, setTagsDropdownList] = useState([])
    const [selectedTagOption, setSelectedTagOption] = useState([])

    const [productsDropDownList, setProductsDropdownList] = useState([])
    const [selectedProductListOption, setSelectedProductListOption] = useState([])

    const [businessCityList, setBusinessCityList] = useState([])
    const [selectedBusinessCity, setSelectedBusinessCity] = useState([])

    const [displayRecordCount, setDisplayRecordCount] = useState({displayCount: true, count: 0})

    const [catalogueOptions, setCatalogueOptions] = useState([
        {
            value: "Yes",
            label: "Yes"
        },
        {
            value: "No",
            label: "No"
        }
    ])
    const [selectedCatalogueOption, setSelectedCatalogueOption] = useState([])

    const [searchFields, setSearchFields] = useState({
        sContactNumber: ""
    })

    // Opportunity Availed Modal States

    const [oppAvailedModal, setOppAvailedModal] = useState(false)
    const [umcTableData, setUmcTableData] = useState([])
    const [loadingInModal, setLoadingInModal] = useState(false)

    // Pagination States
    const [pages, setPages] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setcurrentPage] = useState(0);
    const [tableInstance, setTableInstance] = useState(null);
    const [pageSizeOptions, setpageSizeOptions] = useState([
        {
            value: "10",
            label: "10 Rows",
        },
        {
            value: "20",
            label: "20 Rows",
        },
        {
            value: "30",
            label: "30 Rows",
        },
        {
            value: "50",
            label: "50 Rows",
        },
        {
            value: "75",
            label: "75 Rows",
        },
        {
            value: "100",
            label: "100 Rows",
        },
    ]);
    const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
        value: "10",
        label: "10",
    });
    const [umcAvailedDataModal, setUmcAvailedDataModal] = useState(false)
	const [umcAvailedData, setUmcAvailedData] = useState([])

    const openUmcAvailedDataModalIsTrue = () => {
		setUmcAvailedDataModal(true)
	}

	const openUmcAvailedDataModalIsFalse = () => {
		setUmcAvailedDataModal(false)
		setUmcAvailedData([])
	}

    const onAvailedCountClick = (data) => {
		// openUmcAvailedDataModalIsTrue()
		setLoadingInModal(true)
		const {tempUMCAvailedTable} = api.umcOppurtunitiesOfUserApiAllDetails({
			nUserId: data.nUserId,
			sServiceCodes: data.sServiceCode
		}).then(({data}) => {
			setLoadingInModal(false)
			console.log("Service Data", data.data[0]['Availed Details'])
			setUmcAvailedData(data.data[0]['Availed Details'])
			openUmcAvailedDataModalIsTrue()
		})
	}

    const openOppAvailedModalisTrue = () => {
        setOppAvailedModal(true)
    }

    const openOppAvailedModalisFalse = () => {
        setOppAvailedModal(false)
        setUmcTableData([])
    }

    
    const LineBreakRenderer = ({ data }) => {
        const availedDetails = data["Availed Details"];
        if (!availedDetails || !Array.isArray(availedDetails)) return null;
    
        const instanceIds = availedDetails.map(item => item.nResourceInstanceId).join('\n');
        return (
            <div style={{ whiteSpace: 'pre-line', padding: "6px 0px", lineHeight: 2  }}>
                {instanceIds}
            </div>
        );
    };

    const DateRequestedRenderer = ({ data }) => {
        const availedDetails = data["Availed Details"];
        if (!availedDetails || !Array.isArray(availedDetails)) return null;
    
        const dates = availedDetails.map(item =>
            new Date(item.dtRequested).toLocaleDateString("en-GB")
        ).join('\n');
        return (
            <div style={{ whiteSpace: 'pre-line', padding: "6px 0px", lineHeight: 2  }}>
                {dates}
            </div>
        );
    };

    const columnDefs1 = [
		{
			headerName: 'Resource Id',
			field: 'nResourceInstanceId',
			// flex: 1,
			width:120,
		},
		{
			headerName: 'Opp Title',
			field: 'sServiceDisplayName',
			// flex: 1,
			width:400,
			cellStyle: { 'white-space': 'normal' },
            autoHeight: true,
		},
		{
			headerName: 'Delivered Date',
			field: 'dtDelivered',
			flex: 1,
			valueFormatter: (params) => {
				// Check if there is a date value
				if (params.value) {
					// Create a new Date object from the ISO string
					const date = new Date(params.value);
					// Format it to en-CA (YYYY-MM-DD)
					return date.toLocaleDateString('en-GB');
				}
				return '';
			}
		},
		{
			headerName: 'Company Name',
			field: 'sCompanyName',
			flex: 1,
			valueFormatter: (params) => {
				// Check if the value is "Null"
				return params.value === "Null" ? 'NA' : params.value;
			}
		},
		{
			headerName: 'Company Location',
			field: 'sCompanyLocation',
			flex: 1,
			valueFormatter: (params) => {
				// Check if the value is "Null"
				return params.value === "Null" ? 'NA' : params.value;
			}
		},
	]

    const columnDefs = [
        {
            headerName: 'Type',
            field: 'sServiceCode',
            width: 400,
            flex: 1,
            valueFormatter: params => {
                switch (params.value) {
                    case 'MKTLINKAGEBULKBUYER':
                        return 'Bulk Buyer';
                    case 'MKTLINKAGEECOM':
                        return 'E Commerce';
                    case 'MKTLINKAGECORPLINKAGE':
                        return 'Corporate Linkage';
                    case 'MKTLINKAGESHOPINSHOP':
                        return 'Shop in Shop';
                    case 'MKTLINKAGEEXHIBITION':
                        return 'Exhibition';
                    case 'MKTLINKAGEEXPORT':
                        return 'Exports';
                    default:
                        return params.value;
                }
            },
        },
        {
            headerName: 'Opportunities Availed',
            field: 'Oppu Availed',
            // flex: 1,
            width: 200,
            cellRendererFramework: (params) => {
                const value = params.value;
                const row = params.data;

                return (
                    <div className=''>
                        {value && value !== 0 ? (
                            <a
                                href='#'
                                style={{ textDecoration: 'underline', color: '#78417C' }}
                                onClick={() => onAvailedCountClick(row)}
                            >
                                {value}
                            </a>
                        ) : (
                            value
                        )}
                    </div>
                );
            }
        },
        {
            headerName: 'Availed Details',
            children: [
                {
                    headerName: 'InstanceID',
                    field: 'AvailedDetails',
                    flex: 1,
                    cellRendererFramework: LineBreakRenderer,
                    autoHeight: true,
                    wrapText: true
                },
                {
                    headerName: 'Date Requested',
                    field: 'AvailedDetails',  // Assuming 'AvailedDetails' is the key where you store the concatenated string
                    flex: 1,
                    cellRendererFramework: DateRequestedRenderer,
                    autoHeight: true,
                }
            ]
        }
    ]

//     const columnDefs = [
//         // {
//         //     headerName: 'Type',
//         //     field: 'sServiceCode',
//         //     width: 400,
//         //     flex: 1,
//         //     valueFormatter: params => {
//         //         switch (params.value) {
//         //             case 'MKTLINKAGEBULKBUYER':
//         //                 return 'Bulk Buyer';
//         //             case 'MKTLINKAGEECOM':
//         //                 return 'E Commerce';
//         //             case 'MKTLINKAGECORPLINKAGE':
//         //                 return 'Corporate Linkage';
//         //             case 'MKTLINKAGESHOPINSHOP':
//         //                 return 'Shop in Shop';
//         //             case 'MKTLINKAGEEXHIBITION':
//         //                 return 'Exhibition';
//         //             case 'MKTLINKAGEEXPORT':
//         //                 return 'Exports';
//         //             default:
//         //                 return params.value;
//         //         }
//         //     },
//         //     // cellStyle: { textAlign: "right" },
//         //     // valueFormatter: params => numberFormatter.format(params.value),
//         //     // headerComponentFramework: (params) => {
//         //     //   return (
//         //     // 	<div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center" }}>
//         //     // 	  <div>{params.displayName}</div>
//         //     // 	</div>
//         //     //   );
//         //     // },
//         // },
//         //   { 
//         // 	headerName: 'Title', 
//         // 	field: 'sServiceDisplayName', 
//         //     // width: 230,
//         //     flex:1,
//         //     cellStyle: { 
//         //         whiteSpace: 'normal', 
//         //         wordWrap: 'break-word',
//         //         lineHeight: '1.8'
//         //       },
//         //       autoHeight: true,  // Automatically adjust row height based on cell content
//         // 	// cellStyle: { textAlign: "right" },
//         // 	// valueFormatter: params => numberFormatter.format(params.value),
//         // 	// headerComponentFramework: (params) => {
//         // 	//   return (
//         // 	// 	<div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center" }}>
//         // 	// 	  <div>{params.displayName}</div>
//         // 	// 	</div>
//         // 	//   );
//         // 	// },
//         //   },
//         // {
//         //     headerName: 'Opportunities Availed',
//         //     field: 'Oppu Availed',
//         //     flex: 1,
//         //     // width: 140
//         //     // cellStyle: { textAlign: "right" },
//         //     // valueFormatter: params => numberFormatter.format(params.value),
//         //     // headerComponentFramework: (params) => {
//         //     //   return (
//         //     // 	<div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center" }}>
//         //     // 	  <div>{params.displayName}</div>
//         //     // 	</div>
//         //     //   );
//         //     // },
//         // },
//         // {
//         //     headerName: 'Availed Details',
//         //     children: [
//         //         {
//         //             headerName: 'InstanceID',
//         //             field: 'AvailedDetails',  // Assuming 'AvailedDetails' is the key where you store the concatenated string
//         //             flex: 1,
//         //             valueFormatter: params => {
//         //                 const availedDetails = params.data["Availed Details"];
//         //                 const instanceIds = availedDetails.map(detail => detail.nResourceInstanceId).join(', ');
//         //                 return instanceIds;
//         //             }
//         //         },
//         //         // {
//         //         //     headerName: 'Display Name',
//         //         //     field: 'AvailedDetails',  // Assuming 'AvailedDetails' is the key where you store the concatenated string
//         //         //     flex: 1,
//         //         //     valueFormatter: params => {
//         //         //         const availedDetails = params.data["Availed Details"];
//         //         //         const instanceIds = availedDetails.map(detail => detail.sServiceDisplayName).join(', ');
//         //         //         return instanceIds;
//         //         //     }
//         //         // },
//         //         // {
//         //         //     headerName: 'Type',
//         //         //     field: 'AvailedDetails',  // Assuming 'AvailedDetails' is the key where you store the concatenated string
//         //         //     flex: 1,
//         //         //     valueFormatter: params => {
//         //         //         const availedDetails = params.data["Availed Details"];
//         //         //         const instanceIds = availedDetails.map(detail => detail.sServiceCode).join(', ');
//         //         //         return instanceIds;
//         //         //     }
//         //         // },

//         //         {
//         //             headerName: 'Date Requested',
//         //             field: 'AvailedDetails',  // Assuming 'AvailedDetails' is the key where you store the concatenated string
//         //             flex: 1,
//         //             valueFormatter: params => {
//         //                 const availedDetails = params.data["Availed Details"];
//         //                 const instanceIds = availedDetails.map(detail => {
//         //                     const formattedDate = format(new Date(detail.dtRequested), 'MM/dd/yyyy HH:mm:ss');
//         //                     return formattedDate;
//         //                 }).join(', ');
//         //                 return instanceIds;
//         //             }
//         //         }

//         //     ]
//         // }

//         {
//             headerName: 'Availed Details',
//             children: [
//                 {
//                     headerName: 'Type',
//                     field: 'sServiceCode',
//                     width: 400,
//                     flex: 1,
//                     valueFormatter: params => {
//                         switch (params.value) {
//                             case 'MKTLINKAGEBULKBUYER':
//                                 return 'Bulk Buyer';
//                             case 'MKTLINKAGEECOM':
//                                 return 'E Commerce';
//                             case 'MKTLINKAGECORPLINKAGE':
//                                 return 'Corporate Linkage';
//                             case 'MKTLINKAGESHOPINSHOP':
//                                 return 'Shop in Shop';
//                             case 'MKTLINKAGEEXHIBITION':
//                                 return 'Exhibition';
//                             case 'MKTLINKAGEEXPORT':
//                                 return 'Exports';
//                             default:
//                                 return params.value;
//                         }
//                     },
//                 },
//                 {
//                     headerName: 'Opportunities Availed',
//                     field: 'Oppu Availed',
//                     flex: 1,
//                 },
//                 {
//                     headerName: 'InstanceID',
//                     field: 'AvailedDetails',
//                     flex: 1,
//                     cellRendererFramework: LineBreakRenderer,
//                     autoHeight: true,
//                     wrapText: true
//                 },
//                 // {
//                 //     headerName: 'Display Name',
//                 //     field: 'AvailedDetails',  // Assuming 'AvailedDetails' is the key where you store the concatenated string
//                 //     flex: 1,
//                 //     valueFormatter: params => {
//                 //         const availedDetails = params.data["Availed Details"];
//                 //         const instanceIds = availedDetails.map(detail => detail.sServiceDisplayName).join('\n');
//                 //         return instanceIds;
//                 //     }
//                 // },
//                 // {
//                 //     headerName: 'Type',
//                 //     field: 'AvailedDetails',  // Assuming 'AvailedDetails' is the key where you store the concatenated string
//                 //     flex: 1,
//                 //     valueFormatter: params => {
//                 //         const availedDetails = params.data["Availed Details"];
//                 //         const instanceIds = availedDetails.map(detail => detail.sServiceCode).join('\n');
//                 //         return instanceIds;
//                 //     }
//                 // },

//                 {
//                     headerName: 'Date Requested',
//                     field: 'AvailedDetails',  // Assuming 'AvailedDetails' is the key where you store the concatenated string
//                     flex: 1,
//                     // valueFormatter: params => {
//                     //     const availedDetails = params.data["Availed Details"];
//                     //     const instanceIds = availedDetails.map(detail => {
//                     //         // const formattedDate = format(new Date(detail.dtRequested), 'MM/dd/yyyy HH:mm:ss');
//                     //         const formattedDate = new Date(detail.dtRequested).toLocaleDateString("en-CA")
//                     //         return formattedDate;
//                     //     }).join(', ');
//                     //     return instanceIds;
//                     // }
//                     cellRendererFramework: DateRequestedRenderer,
//                     autoHeight: true,
//                 }
//     ]
// }
//     ]

    const onOppAvailedCountClick = (res) => {
        console.log(res)
        openOppAvailedModalisTrue()
        setLoadingInModal(true)
        const { tempUMCTableData } = api.umcOppurtunitiesOfUserApiAwailedDetails({
            nUserId: res.nUserId
        }).then(({ data }) => {
            console.log("Data", data)
            const filteredData = data.data.filter((ele) => ele["Oppu Availed"] !== 0)
            const availedDetails = data.data.map(item => item["Availed Details"]).flat();

            // Example of using flat() for flattening the nested arrays
            console.log("Availed Details", availedDetails);
            setUmcTableData(filteredData)
            setLoadingInModal(false)
            // setLoadingInModal(false)
        })
    }

    const handleChange = (name, value) => {
        const updated = { ...searchFields, [name]: value };
        setSearchFields(updated)
    }

    const onOppTypeChange = (option) => {
        // setSelectedOppTitle(null)
        setSelectedOppType(option)
        setSelectedOppTitle([])
        getOppTitleNames(option)
    }

    const getOppTitleNames = (ele) => {
        if (ele) {
            const { tempOppTitleNames } = api.oppTitleListApi({
                OpportunityType: ele.value
            })
                .then(({ data }) => {
                    const formattedData = data.results.map((ele) => ({
                        value: ele.ResourceName,
                        label: ele.ResourceName
                    }))
                    setOppTitleNameList(formattedData)
                })
        } else {
            setOppTitleNameList([])
            setSelectedOppTitle([])
        }
    }

    // const onOppTitleChange = (option) => {
    //     setSelectedOppTitle(option)
    // }

    const toggleAllOppTitle = () => {
        if (selectedOppTitle.length != oppTitleNameList.length && selectedOppTitle.length != (oppTitleNameList.length + 1)) {
            let temp = []
      
            if (selectedOppTitle.includes({ label: "All", value: "*" })) {
              temp = selectedOppTitle
            } else {
              temp = [{ label: "All", value: '*' }]
            }
      
            let tempSR = oppTitleNameList.map((e) => {
              if (!temp.includes(e)) {
                temp = temp.concat(e)
              }
              return e
            })
            setOppTitleNameList(tempSR)
            setSelectedOppTitle(temp)
          //   getTagsDropdown(processFilters(temp))
          } else {
            setSelectedOppTitle([])
          //   getTagsDropdown(null)
          }
    }

    const onOppTitleChange = (options) => {
        const isAllSelected = options.some((opt) => opt.value === "*");
        if (isAllSelected) {
            setSelectedOppTitle([{ value: "*", label: "All" }]);
            // getTagsDropdown(processFilters(options))
        } else {
            setSelectedOppTitle(options.filter((opt) => opt.value !== "*"));
            // getTagsDropdown(processFilters(options))
        }
    }

    const onBusinessSectorChange = (options) => {
        // setSelectedBusinessSector(option)
        // getTagsDropdown(option)

        const isAllSelected = options.some((opt) => opt.value === "*");
        if (isAllSelected) {
            setSelectedBusinessSector([{ value: "*", label: "All" }]);
            getTagsDropdown(processFilters(options))
        } else {
            setSelectedBusinessSector(options.filter((opt) => opt.value !== "*"));
            getTagsDropdown(processFilters(options))
        }
    }

    const toggleAllSector = () => {
        if (selectedBusinessSector.length != businessSectorList.length && selectedBusinessSector.length != (businessSectorList.length + 1)) {
            let temp = []

            if (selectedBusinessSector.includes({ label: "All", value: "*" })) {
                temp = selectedBusinessSector
            } else {
                temp = [{ label: "All", value: '*' }]
            }

            let tempSR = businessSectorList.map((e) => {
                if (!temp.includes(e)) {
                    temp = temp.concat(e)
                }
                return e
            })
            setBusinessSectorList(tempSR)
            setSelectedBusinessSector(temp)
            getTagsDropdown(processFilters(temp))
        } else {
            setSelectedBusinessSector([])
            getTagsDropdown(null)
        }

    }

    // const getTagsDropdown = (e) => {
    //     if (e !== null) {
    //         api.tagsListApi(e.value === "Not Defined" || e.value === "notdefined" ? "Others" : e.value)
    //             .then(({ data }) => {
    //                 if (data.data.length > 0) {
    //                     const formattedData = data.data[0]["sTag"]
    //                         .map((ele) => ({
    //                             value: ele,
    //                             label: ele
    //                         }))

    //                     setTagsDropdownList(formattedData)
    //                     console.log("Drop list", formattedData)
    //                 } else {
    //                     setTagsDropdownList([])
    //                 }
    //             })
    //     } else {
    //         setTagsDropdownList([])
    //         setSelectedTagOption([])
    //     }
    // }

    const getTagsDropdown = (e) => {
        if (e !== null) {
            api.tagsListApi(e)
                .then(({ data }) => {
                    if (data.data.length > 0) {
                        // Flatten all sTag arrays into a single array
                        const allTags = data.data.flatMap(sector => sector.sTag);

                        // Remove duplicates
                        const uniqueTags = [...new Set(allTags)];

                        // Format the tags for the dropdown
                        const formattedData = uniqueTags.map(tag => ({
                            value: tag,
                            label: tag
                        }));

                        setTagsDropdownList(formattedData);
                        console.log("Drop list", formattedData);
                    } else {
                        setTagsDropdownList([]);
                    }
                })
                .catch(error => {
                    console.error("API error:", error);
                    setTagsDropdownList([]);
                });
        } else {
            setTagsDropdownList([]);
            setSelectedTagOption([]);
        }
    };

    const onTagChange = (options) => {
        // setSelectedTagOption(option)
        console.log(options, ">>>>options in onTagChange");
        

        const isAllSelected = options.some((opt) => opt.value === "*");
        if (isAllSelected) {
            setSelectedTagOption([{ value: "*", label: "All" }]);
            // getTagsDropdown(processFilters(options))
        } else {
            setSelectedTagOption(options.filter((opt) => opt.value !== "*"));
            // getTagsDropdown(processFilters(options))
        }
    }

    // const getProductListDropdown = (e) => {
    //     if (e !== null) {
    //         api.productListApi(e)
    //             .then(({ data }) => {
    //                 // if (data.data.length > 0) {
    //                 //     // Flatten all sTag arrays into a single array
    //                 //     const allTags = data.data.flatMap(sector => sector.sTag);

    //                 //     // Remove duplicates
    //                 //     const uniqueTags = [...new Set(allTags)];

    //                 //     // Format the tags for the dropdown
    //                 //     const formattedData = uniqueTags.map(tag => ({
    //                 //         value: tag,
    //                 //         label: tag
    //                 //     }));

    //                 //     setProductsDropdownList(formattedData);
    //                 //     console.log("Drop list", formattedData);
    //                 // } else {
    //                 //     setProductsDropdownList([]);
    //                 // }

    //                 console.log(data, ">>>Data on productListAPI called");
    //             })
    //             .catch(error => {
    //                 console.error("API error:", error);
    //                 setProductsDropdownList([]);
    //             });
    //     } else {
    //         setProductsDropdownList([]);
    //         setSelectedProductListOption([]);
    //     }
    // };

    const toggleAllTags = () => {
        if (selectedTagOption.length != tagsDropDownList.length && selectedTagOption.length != (tagsDropDownList.length + 1)) {
            let temp = []

            if (selectedTagOption.includes({ label: "All", value: "*" })) {
                temp = selectedTagOption
            } else {
                temp = [{ label: "All", value: '*' }]
            }

            let tempSR = tagsDropDownList.map((e) => {
                if (!temp.includes(e)) {
                    temp = temp.concat(e)
                }
                return e
            })
            setTagsDropdownList(tempSR)
            setSelectedTagOption(temp)
        } else {
            setSelectedTagOption([])
        }

    }

    const onBusinessCityChange = (options) => {
        // setSelectedBusinessCity(option)
        console.log(options, ">>>options onBusinessCityChange");
        
        const isAllSelected = options.some((opt) => opt.value === "*");
        console.log(isAllSelected, ">>>>isAllSelected onBusinessCityChange");

        if (isAllSelected) {
            console.log(">>>>entered if of businessCItyChange");
            
            setSelectedBusinessCity([{ value: "*", label: "All" }]);
        } else {
            console.log(">>>>entered else of businessCItyChange");
            setSelectedBusinessCity(options.filter((opt) => opt.value !== "*"));
        }
    }

    const toggleAllBusinessCity = () => {
        if (selectedBusinessCity.length != businessCityList.length && selectedBusinessCity.length != (businessCityList.length + 1)) {
            let temp = []

            if (selectedBusinessCity.includes({ label: "All", value: "*" })) {
                temp = selectedBusinessCity
            } else {
                temp = [{ label: "All", value: '*' }]
            }

            let tempSR = businessCityList.map((e) => {
                if (!temp.includes(e)) {
                    temp = temp.concat(e)
                }
                return e
            })
            setBusinessCityList(tempSR)
            setSelectedBusinessCity(temp)
        } else {
            setSelectedBusinessCity([])
        }

    }

    const onProductListOptionChange = (options) => {
        console.log(options, ">>>>options on onProductListOptionChange");
        
        const isAllSelected = options.some((opt) => opt.value === "*");
        console.log(isAllSelected, ">>>>isAllSelected onProductListOptionChange");

        if (isAllSelected) {
            console.log(">>>>entered if of onProductListOptionChange");
            setSelectedProductListOption([{ value: "*", label: "All" }]);
        } else {
            console.log(">>>>entered else of onProductListOptionChange");
            setSelectedProductListOption(options.filter((opt) => opt.value !== "*"));
        }
    }

    const toggleAllProductList = () => {
        if (selectedProductListOption.length != productsDropDownList.length && selectedProductListOption.length != (productsDropDownList.length + 1)) {
            let temp = []

            if (selectedProductListOption.includes({ label: "All", value: "*" })) {
                temp = selectedProductListOption
            } else {
                temp = [{ label: "All", value: '*' }]
            }

            let tempSR = productsDropDownList.map((e) => {
                if (!temp.includes(e)) {
                    temp = temp.concat(e)
                }
                return e
            })
            setProductsDropdownList(tempSR)
            setSelectedProductListOption(temp)
        } else {
            setSelectedProductListOption([])
        }

    }

    const onCatalogueOptionChange = (option) => {
        setSelectedCatalogueOption(option)
    }

    const umcCustomersData = async (instance, flag = false) => {
        if (!instance) return;
        if (!tableInstance) setTableInstance(instance);

        try {
            const { page } = instance.state ?? { page: 0 };
            let icurrentPage = page;
            if (!flag && isNaN(icurrentPage)) return;
            const pageSize = selectedPageSizeOption.value;

            if (flag || isNaN(icurrentPage)) {
                icurrentPage = 0;
            }

            let ServiceDisplayNameTemp = []
            selectedOppTitle.map((ele) => {
                if (ele.value !== "*") {
                    ServiceDisplayNameTemp.push(ele.value)
                }
            })


            let filterParameters = {
                page: icurrentPage + 1,
                page_size: pageSize,
                // pagination: true,
                // SP_email: 'archana.sapre@mailinator.com'
            };

            if (selectedOppType) {
                filterParameters.sServiceCode = selectedOppType.value
            }

            if (selectedOppTitle) {
                filterParameters.sServiceDisplayName = ServiceDisplayNameTemp
            }

            // if (selectedOppTitle.length > 0) {
            //     filterParameters.sServiceDisplayName = processFilters(selectedOppTitle) 
            // }

            if (selectedBusinessSector.length > 0) {
                filterParameters.sBusinessSector = processFilters(selectedBusinessSector)
            }

            if (selectedProductListOption.length > 0) {
                filterParameters.sProductList = processFilters(selectedProductListOption)
            }

            if (selectedBusinessCity.length > 0) {
                filterParameters.sBusinessCity = processFilters(selectedBusinessCity)
            }

            if (selectedTagOption.length > 0) {
                filterParameters.sTag = processFilters(selectedTagOption)
            }

            if (selectedCatalogueOption) {
                filterParameters.sCatalogue = selectedCatalogueOption.value
            }

            if (searchFields.sContactNumber !== "") {
                filterParameters.sContactNumber = searchFields.sContactNumber
            }
            setIsLoading(true)
            const { tempUmcCustomers } = api.umcCustomersAPI(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        const { results, count } = data;
                        setcurrentPage(icurrentPage);
                        const totalPages = (count - 1) / pageSize + 1;
                        setDisplayRecordCount({...displayRecordCount, count: data?.count})
                        // setCount(count);
                        setPages(Math.floor(totalPages));
                        setPageSize(pageSize);
                        setData(results);
                        setIsLoading(false)
                    }
                }).catch(err =>{
                    console.log("Error getting UMC customers");
                    setIsLoading(false)
                })
        } catch (error) {
            console.log(error)
            setIsLoading(false)
            // toast("Internal Server Error", {
            //     autoClose: 5000,
            //     type: toast.TYPE.ERROR,
            // });
        }
    }

    const fetchServiceRequests = (instance, flag) => {
        umcCustomersData(instance, flag);
    };

    const onSearchClick = () => {
        //     let cityNames = "";
        // if (selectedBusinessCity.length > 1) {
        //     cityNames = selectedBusinessCity.map(city => city.value).join(", ");
        // } else if (selectedBusinessCity.length === 1) {
        //     cityNames = selectedBusinessCity[0].value;
        // }
        // console.log(cityNames);
        umcCustomersData(tableInstance, true)
    }

    const onClearClick = () => {
        setSelectedOppType(null)
        setSelectedOppTitle([])
        setSelectedBusinessSector([])
        setSelectedBusinessCity([])
        setSelectedTagOption([])
        setSelectedCatalogueOption([])
        setSelectedProductListOption([])
        setSearchFields({
            sContactNumber: ""
        })

        setIsClearAction(true);
    }

    useEffect(() => {
        if (isClearAction) {
            // Call umcCustomersData only after state updates have been completed
            umcCustomersData(tableInstance, true);
            
            // Reset the clear action flag
            setIsClearAction(false);
        }
    }, [
        isClearAction // This ensures the function is called after clearing
    ]);

    const onDownloadClick = () => {

        let ServiceDisplayNameTemp = []
        selectedOppTitle.map((ele) => {
            if (ele.value !== "*") {
                ServiceDisplayNameTemp.push(ele.value)
            }
        })



        let filterParameters = []
        if (selectedOppType) {
            filterParameters.sServiceCode = selectedOppType.value
        }

        // if (selectedOppTitle) {
        //     filterParameters.sServiceDisplayName = selectedOppTitle.value
        // }

        if (selectedOppTitle) {
            filterParameters.sServiceDisplayName = ServiceDisplayNameTemp
        }

        // if (selectedOppTitle.length > 0) {
        //     filterParameters.sServiceDisplayName = processFilters(selectedOppTitle) 
        // }

        if (selectedBusinessSector.length > 0) {
            filterParameters.sBusinessSector = processFilters(selectedBusinessSector)
        }

        if (selectedBusinessCity.length > 0) {
            filterParameters.sBusinessCity = processFilters(selectedBusinessCity)
        }

        if (selectedProductListOption.length > 0) {
            filterParameters.sProductList = processFilters(selectedProductListOption)
        }

        if (selectedTagOption.length > 0) {
            filterParameters.sTag = processFilters(selectedTagOption)
        }

        if (selectedCatalogueOption) {
            filterParameters.sCatalogue = selectedCatalogueOption.value
        }

        if (searchFields.sContactNumber !== "") {
            filterParameters.sContactNumber = searchFields.sContactNumber
        }

        setIsLoading(true)
        const { tempDownloadCustomerUmc } = api.umcCustomerDownlaodApi(filterParameters)
            .then(({ data }) => {
                console.log(data, ">>>Data in umcCustomerDownlaodApi");
                if(data?.details){
                    toast(data["details"], {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    });
                }
                
                window.open(data["generated_file"], "_self");
                // setLoading(false);
                setIsLoading(false)
            })
            .catch((error) => {
                // setLoading(false);
                setIsLoading(false)
                toast(error["response"]["data"]["message"], {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            });
    }

    const processFilters = (filter) => {
        let filterNames = ""
        if (filter.length > 1) {
            filterNames = filter.map(city => city.value).join(", ");
        } else if (filter.length === 1) {
            filterNames = filter[0].value;
        }

        return filterNames
    }

    const handleCatalogueClick = (ele) => {
        setIsLoading(true)
        let payload = {
            api_key: "r54B?rHXUE7v%$9t",
            user_id: ele._original.nUserId
        }

        const { tempCataloguelinkData } = api.catalogueLinkApi(payload)
            .then(({ data }) => {
                console.log("Link", data)
                if (data.data !== null) {
                    window.open(data.data.catalogue_url, "_blank");
                    setIsLoading(false)
                }
            })
    }

    useEffect(() => {
        const { tempOppTypeServiceNames } = api.oppTypeListApi()
            .then(({ data }) => {
                const formattedData = data.results.map((ele) => ({
                    value: ele.sServiceCode,
                    label: ele.sServiceName
                }))
                setOppTypeNameList(formattedData)
            })

        const { tempBusinessSectorListApi } = api.businessSectorListApi()
            .then(({ data }) => {
                console.log("Business Sector", data)
                const formattedData = data.data
                    .filter(ele => ele.sBusinessSector !== null)
                    .map((ele) => ({
                        value: ele.sBusinessSector,
                        label: ele.sBusinessSector
                    }))
                setBusinessSectorList(formattedData)
            })

        const { tempBusinessCityListApi } = api.businessCityListApi()
            .then(({ data }) => {
                console.log(data, ">>>>businessCityListApi data");
                
                const formatttedData = data.data
                    .map((ele) => ({
                        value: ele.sBusinessCity,
                        label: ele.sBusinessCity
                    }))

                console.log(formatttedData, ">>>>formatttedData businessCityListApi");
                
                setBusinessCityList(formatttedData)
            })

        const {tempProductListAPi} = api.productListApi()
        .then(({data}) => {
            console.log(data, ">>>>>productListApi api call data");

            let uniqueData = {};

            data.forEach(elem => {
                if(uniqueData[elem]){
                    uniqueData[elem] = uniqueData[elem] + 1
                } else {
                    uniqueData[elem] =  1
                }
            })

            console.log(uniqueData, ">>>uniqueData");

            let allKeys = Object.keys(uniqueData)
            console.log(allKeys, ">>allkeys unique data");
            

            const formatttedData = allKeys
                    .map((ele) => ({
                        value: ele,
                        label: ele
                    }))

            console.log(formatttedData ,">>>>formatttedData productListApi");
            setProductsDropdownList(formatttedData);
        }).catch(err =>{
            console.log("Error getting product list", err);
            setProductsDropdownList([]);
        })
    }, [])

    useEffect(() => {
        umcCustomersData(tableInstance, true)
    }, [selectedPageSizeOption])

    // below state and function for customer user selection
    const [selectedUsers, setSelectedUsers] = useState([]);

    // const handleCheckboxChange = (nUserId) => {
    //     console.log(nUserId, ">>>>ServiceInstanceId");
        
    //     const currentIndex = selectedUsers.indexOf(nUserId);
    //     const newSelectedUsers = [...selectedUsers];

    //     if (currentIndex === -1) {
    //         newSelectedUsers.push(nUserId);
    //     } else {
    //         newSelectedUsers.splice(currentIndex, 1);
    //     }

    //     setSelectedUsers(newSelectedUsers);
    //     console.log("Selected Service", newSelectedUsers)
    // };

    const handleCheckboxChange = (nUserId) => {
        console.log(nUserId, ">>>>ServiceInstanceId");
        
        const currentIndex = selectedUsers.indexOf(nUserId);
        const newSelectedUsers = [...selectedUsers];

        if (currentIndex === -1) {
            newSelectedUsers.push(nUserId);
        } else {
            newSelectedUsers.splice(currentIndex, 1);
        }

        setSelectedUsers(newSelectedUsers);
        console.log("Selected Service", newSelectedUsers)
    };

    const isSelected = (nUserId) => selectedUsers.includes(nUserId);

    const handleSelectAll = () => {
        // const selectableServices = data.filter(service => service.custrefSRState !== 'Delivered' && service.custrefSRState !== 'Cancelled');
        const selectedUserIds = data.map(user => user.nUserId);
    
        if (selectedUsers.length === selectedUserIds.length) {
            // Deselect all services
            setSelectedUsers([]);
        } else {
            // Select all services
            setSelectedUsers(selectedUserIds);
        }
        console.log("Serv", selectedUserIds)
    };

    // below function and state for sendsms model
    const [openSendSmsModel, setOpenSendSmsModel] = useState(false);

    const [allTypeListTitle, setAllTypeListTitle] = useState(null);

    const [uniqueOppTypeListForSendSms, setUniqueOppTypeNameListForsendSms] = useState([]);
    const [oppTitleListForSendSms, setOppTitleListForSendSms] = useState([]);

    const [selectedOppTypeForSendSms, setSelectedOppTypeForSendSms] =  useState();
    const [selectedOppTitleForSendSms, setSelectedOppTitleForSendSms] = useState();

    const [selectedOppTitleDetails, setSelectedOppTitleDetails] = useState(null);


    const getOppList = async() =>{
        console.log(">>>getOppList called");
        try{
            let oppListData = await api.getOpportunitiesListing();
            return oppListData
        } catch(err){
            console.log("Error getting Opp listings");
        }
    }

    const handleOpenSendSmsModel = (val) =>{
        setOpenSendSmsModel(val);

        if(val){
            setLoadingInModal(true)
            getOppList().then(res => {
                console.log(res, ">>>>resss getOppList");
                let allOppList = res?.data?.Data?.opportunity_list;

                let uniqueOppType = {};

                allOppList.forEach(opp => {
                    if(!uniqueOppType[opp.opportunity_type]){
                        uniqueOppType[opp.opportunity_type] = 1
                    } else{
                        uniqueOppType[opp.opportunity_type]++
                    }
                })

                let allUniqueKeys = Object.keys(uniqueOppType)
                let uniqueOppTypeFormatForOptions = allUniqueKeys.map(oppType => {
                    return {value: oppType, label: oppType}
                })
                setUniqueOppTypeNameListForsendSms(uniqueOppTypeFormatForOptions);
                setAllTypeListTitle(allOppList);

                setLoadingInModal(false)
            }).catch(err=>{
                console.log("ERROR: error fetching opp. listing");
                setLoadingInModal(false)
            })
        } else {
            setOpenSendSmsModel(val);
            setLoadingInModal(false)
        }
    }

    const handleCloseSmsModel = () =>{
        setOpenSendSmsModel(false);
        setSelectedOppTypeForSendSms();
        setSelectedOppTitleForSendSms()
    }

    const handleOppTypeChange = (option) => {
        console.log(option, ">>> option on handleOppTypeChange");

        if(option){
            setSelectedOppTypeForSendSms(option)

            let allTitleOfSelectedType = allTypeListTitle.filter(obj => {
                return obj.opportunity_type == option?.value
            })
            // console.log(allTitleOfSelectedType, ">>>>allTitleOfSelectedType");
    
            let titleListFormatForOptions = allTitleOfSelectedType?.map(obj => {
                return {
                    value: obj?.opportunity_title , label: obj?.opportunity_title
                }
            })
            console.log(titleListFormatForOptions, ">>>>>titleListFormatForOptions"); 
            setOppTitleListForSendSms(titleListFormatForOptions)  
        }   else {
            setSelectedOppTypeForSendSms();
            setSelectedOppTitleForSendSms()
            setOppTitleListForSendSms([])
        } 
    }

    const handleOppTitleChange = async(option) =>{
        console.log(option, ">>>option");

        setLoadingInModal(true);
        try{
            const selectedTitle = allTypeListTitle.find(obj => {
                return obj?.opportunity_title == option?.value
            })
            // console.log(selectedTitle, ">>>selectedTitle");
            const selectedTitleOppId = selectedTitle?.opportunity_id
            // console.log(selectedTitleOppId, ">>>selectedTitleOppId");

            let selectedTitleDetails = await api.getSelectedOppTitleDetails(selectedTitleOppId);
            let details = selectedTitleDetails?.data?.Data;
            console.log(details, ">>>>>details");

            setSelectedOppTitleDetails(details)

            setLoadingInModal(false)
        }catch(err){
            console.log("Error: Failed to get title details");
            setLoadingInModal(false);
        }
        
        if(option){
            setSelectedOppTitleForSendSms(option)
        }else {
            setSelectedOppTitleForSendSms();
        }
    }

    const handleSendMessage = async() =>{
        console.log(selectedUsers, ">>>SelectedUsers")
        console.log(selectedOppTitleDetails, ">>>>>selectedOppTitleDetails");

        let payloadData = {
            selectedUsers : [...selectedUsers],
            ...selectedOppTitleDetails
        }

        setLoadingInModal(true);
        try{
            let res = await api.sendOppDetailToCustomer(payloadData);

            // console.log(res?.data?.message, ">>>>>res message");
            
            toast(res?.data?.message, {
                autoClose: 5000,
                type: toast.TYPE.SUCCESS,
            });
            // console.log(res?.data?.message, ">>>>>Res");


            setSelectedOppTitleDetails(null);
            setSelectedOppTitleForSendSms();
            setSelectedOppTypeForSendSms()
            setOppTitleListForSendSms([]);
            setUniqueOppTypeNameListForsendSms([]);
            setAllTypeListTitle(null);
            setOpenSendSmsModel(false);
            setSelectedUsers([]);

            setLoadingInModal(false);
        } catch(err){
            console.log("ERROR: Error in sending title details to customers");
            // toast(res?.data?.message, {
            //     autoClose: 5000,
            //     type: toast.TYPE.ERROR,
            // });
            setSelectedOppTitleDetails(null);
            setSelectedOppTitleForSendSms();
            setSelectedOppTypeForSendSms()
            setOppTitleListForSendSms([]);
            setUniqueOppTypeNameListForsendSms([]);
            setAllTypeListTitle(null);
            setOpenSendSmsModel(false);
            setSelectedUsers([]);

            setLoadingInModal(false);
        }
    }


    // console.log(selectedBusinessCity, ">>>selectedBusinessCIty");
    // console.log(selectedProductListOption, ">>>>selectedProductListOption");
    // console.log(selectedUsers, ">>>>selectedUsers");
    // console.log(openSendSmsModel, ">>>openSendSmsModel");

    // console.log(selectedUsers, ">>>>selectedUsers");
    // console.log(uniqueOppTypeListForSendSms, ">>>uniqueOppTypeListForSendSms");
    // console.log(allTypeListTitle, ">>>>allTypeListTitle");

    // console.log(selectedOppTypeForSendSms, ">>>>>selectedOppTypeForSendSms");
    // console.log(selectedOppTitleForSendSms, ">>>>selectedOppTitleForSendSms");
    return (
        <div className={`${isLoading && "set-opacity"}`}>
            {isLoading && <Spinner className="center-screen" />}

            <div className="row">
                <div className="col-2 mt-2 spled-container" style={{zIndex:"3"}}>
                    <Select
                        options={oppTypeNameList}
                        onChange={onOppTypeChange}
                        value={selectedOppType}
                        placeholder="Select Opp Type"
                        isClearable
                    />
                </div>

                <div className="col-2 mt-2 spled-container conv-zindex">
                    {/* <Select
                        options={oppTitleNameList}
                        onChange={onOppTitleChange}
                        value={selectedOppTitle}
                        placeholder="Select Opp Title"
                        isClearable
                    /> */}
                     <MultiSelectAll
                        toggleAll={toggleAllOppTitle}
                        toggleSelection={onOppTitleChange}
                        checkboxItemsList={oppTitleNameList}
                        selectedOptions={selectedOppTitle}
                        placeholderButtonLabel="Select Opp Title"
                    />
                </div>

                <div className="col-2 mt-2 spled-container conv-zindex">
                    {/* <Select
                      options={businessSectorList}
                      placeholder="Select Sector"
                      onChange={onBusinessSectorChange}
                      value={selectedBusinessSector}
                      isClearable
                  /> */}
                    <MultiSelectAll
                        toggleAll={toggleAllSector}
                        toggleSelection={onBusinessSectorChange}
                        checkboxItemsList={businessSectorList}
                        selectedOptions={selectedBusinessSector}
                        placeholderButtonLabel="Select Sector"
                    />
                </div>

                <div className="col-2 mt-2 spled-container conv-zindex">
                    {/* <Select
                      options={tagsDropDownList}
                      placeholder="Select Tag"
                      onChange={onTagChange}
                      value={selectedTagOption}
                      isClearable
                  /> */}
                    <MultiSelectAll
                        toggleAll={toggleAllTags}
                        toggleSelection={onTagChange}
                        checkboxItemsList={tagsDropDownList}
                        selectedOptions={selectedTagOption}
                        placeholderButtonLabel="Select Tags"
                    />
                </div>

                <div className="col-2 mt-2 spled-container conv-zindex">
                    {/* <Select
                      options={tagsDropDownList}
                      placeholder="Select Tag"
                      onChange={onTagChange}
                      value={selectedTagOption}
                      isClearable
                  /> */}
                    <MultiSelectAll
                        toggleAll={toggleAllProductList}
                        toggleSelection={onProductListOptionChange}
                        checkboxItemsList={productsDropDownList}
                        selectedOptions={selectedProductListOption}
                        placeholderButtonLabel="Select Product List"
                    />
                </div>

                <div className="col-2 mt-2 spled-container conv-zindex">
                    {/* <Select
                      options={businessCityList}
                      placeholder="Select City"
                      onChange={onBusinessCityChange}
                      value={selectedBusinessCity}
                      isClearable
                  /> */}
                    <MultiSelectAll
                        toggleAll={toggleAllBusinessCity}
                        toggleSelection={onBusinessCityChange}
                        checkboxItemsList={businessCityList}
                        selectedOptions={selectedBusinessCity}
                        placeholderButtonLabel="Select City"
                    />
                </div>
            </div>

            <div className="row" style={{
                marginBottom: '15px',
                display: 'flex',
                justifyContent: 'space-between',
                boxShadow: "0 5px 5px -2px rgba(0, 0, 0, 0.5)"
            }}>
                {/* <div className="col-2 ml-5 mt-2 spled-container" style={{
                zIndex: '1000'
            }}>
                  <Select
                      options={catalogueOptions}
                      placeholder="Is Catalogue"
                      onChange={onCatalogueOptionChange}
                      value={selectedCatalogueOption}
                      isClearable
                  />
            </div> */}

                <div className='col-12'>
                    <div className="row">
                        <div className="col-2 mt-2 spled-container conv-zindex">
                            <Select
                                options={catalogueOptions}
                                placeholder="Catlogue-Yes / No"
                                onChange={onCatalogueOptionChange}
                                value={selectedCatalogueOption}
                                isClearable
                            />
                        </div>
                        <div className="col-2 mt-2 spled-container">
                            <ControlledInput
                                className="reportInputUmc"
                                name="sContactNumber"
                                placeholder="Contact Number"
                                value={searchFields.sContactNumber}
                                onChange={({ target: { name, value } }) => handleChange(name, value)}
                                //   onKeyDown={(e) => {
                                //       const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                                //       if (
                                //           !/^\d$/.test(e.key) &&
                                //           !allowedKeys.includes(e.key) &&
                                //           e.key !== "Tab"
                                //       ) {
                                //           e.preventDefault();
                                //       }
                                //   }}
                                onKeyDown={(e) => {
                                    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                                    const ctrlKeys = ["a", "c", "v", "x"];

                                    if (
                                        !/^\d$/.test(e.key) && // Allow digits
                                        !allowedKeys.includes(e.key) && // Allow navigation keys
                                        !(e.ctrlKey && ctrlKeys.includes(e.key.toLowerCase())) // Allow Ctrl combinations
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                                autoComplete="off"
                            />
                        </div>

                        <div className='col-5 mt-2 spled-container'>
                            <div className='row'>
                                <div className='col-6'>
                                        <Button style={{
                                        margin: 0,
                                        marginLeft: '0px',
                                        height: '37px'
                                }}
                                    onClick={onSearchClick}
                                    // disabled={!props.selectedBusinessCity}
                                    className="con-btn-filled">Search</Button>

                                <Button style={{
                                    margin: 0,
                                    marginLeft: '20px',
                                    height: '37px'
                                }}
                                    onClick={onClearClick}
                                    // disabled={!props.selectedBusinessCity}
                                    className="con-btn-bordered-lg">Clear</Button>

                                </div>

                                <div className='col-6' style={{ display: 'flex',justifyContent: 'flex-end'}}>
                                    <Button style={{
                                        margin: 0,
                                        marginLeft: '10px',
                                        height: '37px'
                                    }}
                                    onClick={()=>handleOpenSendSmsModel(true)}
                                    disabled={!selectedUsers.length>0}
                                    className="con-btn-filled">New opp. intimation</Button>
                                </div>
                            </div>
                        </div>

                        {/* <div className='col-2'></div> */}


                        <div className="col-3" style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}>
                            <div className='mt-2 spled-container'>
                            
                                <Button style={{
                                    margin: 0,
                                    marginLeft: '10px',
                                    height: '37px'
                                }}
                                    onClick={onDownloadClick}
                                    // disabled={!props.selectedBusinessCity}
                                    className="con-btn-filled">Download CSV</Button>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ESPUmcReportingTable
                data={data}
                onFetchServiceRequests={fetchServiceRequests}
                pages={pages}
                pageSize={pageSize}
                page={currentPage}
                pageSizeOptions={pageSizeOptions}
                selectedPageSizeOption={selectedPageSizeOption}
                onPageSizeOptionChange={(option) => {
                    setSelectedPageSizeOption(option);
                }}
                handleCatalogueClick={handleCatalogueClick}
                onOppAvailedCountClick={onOppAvailedCountClick}
                displayRecordCount={displayRecordCount}
                handleCheckboxChange={handleCheckboxChange}
                isSelected={isSelected}
                handleSelectAll={handleSelectAll}
                selectedUsers={selectedUsers}
            />

            {/* Opportunity Availed Modal */}

            <Modal isOpen={oppAvailedModal}>
                <ModalContent className="umc-details-modal-sp" style={{width:"80%"}}>
                    <div className="modal-header" style={{
                        backgroundColor: '#76287C',
                        color: '#fff'
                    }}>
                        <span className="modal-title">UMC Opportunities</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openOppAvailedModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <div className={`${loadingInModal && "set-opacity"}`}>
                            {loadingInModal && <Spinner className="top" />}
                            <div className='mt-3 mb-3'>
                                {
                                    umcTableData.length > 0 ?
                                        <div className="" style={{
                                            height: "400px",
                                        }}>
                                            <div style={{ height: "100%", boxSizing: "border-box" }}>
                                                <div style={gridStyle} className="ag-theme-material">
                                                    <AgGridReact
                                                        ref={gridRef}
                                                        rowData={umcTableData || []}
                                                        columnDefs={columnDefs}
                                                    >
                                                    </AgGridReact>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="spled-colored-label">
                                            No Data Found
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </ModalContent>
            </Modal>

            <Modal isOpen={umcAvailedDataModal}>
				<ModalContent className="medium-general-modal">
					<div className="modal-header" style={{
						backgroundColor: '#76287C',
						color: '#fff'
					}}>
						<span className="modal-title">Availed Details</span>
						<img
							alt="close"
							id="Close"
							src={close_modal}
							className="close modal-close"
							onClick={openUmcAvailedDataModalIsFalse}
						/>
					</div>

					<div className="modal-body">
					<div>
								{
									umcAvailedData.length > 0 ?
										<div className="" style={{
											height: "300px",
										}}>
											<div style={{ height: "100%", boxSizing: "border-box" }}>
												<div style={gridStyle} className="ag-theme-material">
													<AgGridReact
														ref={gridRef}
														rowData={umcAvailedData || []}
														columnDefs={columnDefs1}
													>
													</AgGridReact>
												</div>
											</div>
										</div>
										:
										<div className="spled-colored-label">
											No Data Found
										</div>
								}
							</div>
					</div>
				</ModalContent>
			</Modal>

            {/* Send sms model */}
            <Modal isOpen={openSendSmsModel}>
                <ModalContent className="sp-umc-sendsms-modal" style={{width:"80%"}}>
                    <div className="modal-header" style={{
                        // backgroundColor: '#76287C',
                        color: '#fff'
                    }}>
                        <span className="modal-title">UMC Opportunities</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={()=>handleCloseSmsModel(false)}
                        />
                    </div>

                    <div className="modal-body">
                            <div className='row pb-2' style={{paddingLeft:"30px", boxShadow: "0 5px 5px -2px rgba(0, 0, 0, 0.5)", backgroundColor:""}}>
                                {/* <div className='col-4'>
                                    <Button style={{
                                        margin: 0,
                                        height: '37px'
                                    }}
                                        onClick={handleGetTitleDetails}
                                        // disabled={!props.selectedBusinessCity}
                                    className="con-btn-filled">
                                        Get Title Details
                                    </Button>
                                </div>     */}
                                <div className='col-4'>
                                        <Button style={{
                                            margin: 0,
                                            height: '37px'
                                        }}
                                            onClick={handleSendMessage}
                                            disabled={!selectedOppTitleForSendSms}
                                        className="con-btn-filled">
                                            Send Message
                                        </Button>
                                </div>                            
                            </div>
                        <div className={`${loadingInModal && "set-opacity"}`}>
                            {loadingInModal && <Spinner className="center" />}
                            <div className='mt-3 mb-3 p-4'>
                                {
                                    <div className="" style={{
                                        height: "300px",
                                    }}>
                                        <div className="row">
                                            <div className="col-6 mt-2 spled-container conv-zindex">
                                                <Select
                                                    options={uniqueOppTypeListForSendSms}
                                                    onChange={handleOppTypeChange}
                                                    value={selectedOppTypeForSendSms}
                                                    placeholder="Select Opp Type"
                                                    isClearable
                                                />
                                            </div>

                                            <div className="col-6 mt-2 spled-container conv-zindex">
                                                {/* <Select
                                                    options={oppTitleNameList}
                                                    onChange={onOppTitleChange}
                                                    value={selectedOppTitle}
                                                    placeholder="Select Opp Title"
                                                    isClearable
                                                /> */}
                                                {/* <MultiSelectAll
                                                    toggleAll={handleToggleAllOppTitle}
                                                    toggleSelection={handleOppTitleChange}
                                                    checkboxItemsList={oppTitleListForSendSms}
                                                    selectedOptions={selectedOppTitleForSendSms}
                                                    placeholderButtonLabel="Select Opp Title"
                                                /> */}

                                                <Select
                                                    options={oppTitleListForSendSms}
                                                    onChange={handleOppTitleChange}
                                                    value={selectedOppTitleForSendSms}
                                                    placeholder="Select Opp Title"
                                                    isClearable
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </ModalContent>
            </Modal>

        </div>
    )
}

export default ESPUmcReportingInterface
